import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import { AppSettingService } from '../app.service';
import { CacheService } from '../utility/cache.service';

export interface IMediaKnownExt {
	Ext: string
}
export interface IMimeType {
	Ext: string,
	FileAllowed: boolean,
	MimeType: string
}

export interface IMediaFile {
	GUID: string,
	File: any,
	Name: string,
	Type: string,
	Size: number,
	Ext: string,
	Icon: string,
	LastModified: Date
}

@Injectable({
	providedIn: 'root'
})
export class MediaAPIService {
	constructor(
		private cacheSrv: CacheService
	) { }

	private knownMediaExts: IMediaKnownExt[] = [
		{ Ext: "au" },
		{ Ext: "avi" },
		{ Ext: "bmp" },
		{ Ext: "doc" },
		{ Ext: "docx" },
		{ Ext: "gif" },
		{ Ext: "gz" },
		{ Ext: "jpg" },
		{ Ext: "midi" },
		{ Ext: "mp3" },
		{ Ext: "mp4" },
		{ Ext: "mpeg" },
		{ Ext: "ogg" },
		{ Ext: "pdf" },
		{ Ext: "png" },
		{ Ext: "ppt" },
		{ Ext: "pptx" },
		{ Ext: "pub" },
		{ Ext: "qt" },
		{ Ext: "ra" },
		{ Ext: "ram" },
		{ Ext: "svg" },
		{ Ext: "swf" },
		{ Ext: "tar" },
		{ Ext: "tgz" },
		{ Ext: "tiff" },
		{ Ext: "tsv" },
		{ Ext: "txt" },
		{ Ext: "wav" },
		{ Ext: "xls" },
		{ Ext: "xlsx" },
		{ Ext: "xlsm" },
		{ Ext: "zip" }
	]


	getMimeType(ext: string): Rx.Observable<IMimeType> {
		let url = AppSettingService.appConfig.JourneyAPIUrl + "FileManagement/MimeType/" + encodeURIComponent(ext);
		return this.cacheSrv.get(true, url);
	}

	getList(): IMediaKnownExt[] {
		return this.knownMediaExts;
	}

	getIcon(ext: string, size: number): string {
		return "/api/images/MimeTypeIcon/" + ext + "-icon-" + size.toString() + "x" + size.toString() + ".png";
	}
}

